import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Grid, Typography, TemplateCard, makeStyles, Divider, FormControlLabel, FormControl, Input, InputAdornment, Checkbox, SearchIcon } from "../../../../../";
import _ from "lodash";
import selects from "../../../../../assets/selects";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: "4px 25px"
    },
    tagList: {
      display: "flex",
      "flex-direction": "column"
    },
    divider: {
      height: "4px"
    },
    mr30: {
      margin: "30px"
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between"
    },
    tabContainer: {
      display: "flex"
    },
    skeleton: {
      padding: "30px",
      width: "60%"
    },
    margin: {
      marginBottom: "20px",
      width: "50%"
    }
  };
});

var FranchiseProjectsBestPracticesList = function FranchiseProjectsBestPracticesList(props) {
  var templates = props.templates,
      translation = props.translation;

  var _useState = useState({
    event: false,
    campus: false,
    academy: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      types = _useState2[0],
      setTypes = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      tags = _useState4[0],
      setTags = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      search = _useState6[0],
      setSearch = _useState6[1];

  var classes = useStyles();

  var handleChange = function handleChange(name, type) {
    return function (event) {
      type === "type" ? setTypes(_objectSpread(_objectSpread({}, types), {}, _defineProperty({}, name, event.target.checked))) : setTags(_objectSpread(_objectSpread({}, tags), {}, _defineProperty({}, name, event.target.checked)));
    };
  };

  var handleSearchChange = function handleSearchChange(event) {
    setSearch(event.target.value);
  };

  var createTagList = function createTagList(templates) {
    var _tags = {};

    _.flatten(_.uniq(templates && templates.map(function (template) {
      return template.tags;
    }))).forEach(function (tag) {
      return _tags[tag] = false;
    });

    return _tags;
  };

  useEffect(function () {
    setTags(createTagList(templates));
  }, [templates]);

  var createFilteredTemplates = function createFilteredTemplates() {
    var auxTemplates = props.templates;

    if (Object.keys(types).filter(function (el) {
      return types[el];
    }).length > 0) {
      var _types = Object.keys(types).filter(function (el) {
        return types[el];
      });

      auxTemplates = auxTemplates.filter(function (template) {
        return _types.includes(template.type);
      });
    }

    if (Object.keys(tags).filter(function (el) {
      return tags[el];
    }).length > 0) {
      // console.log("tags filter activated", tags);
      var _tags = Object.keys(tags).filter(function (el) {
        return tags[el];
      });

      auxTemplates = auxTemplates.filter(function (template) {
        return _.intersection(template.tags, _tags).length > 0;
      });
    }

    if (search !== "") {
      auxTemplates = auxTemplates.filter(function (template) {
        return template.name.toLowerCase().includes(search.toLowerCase()) || template.description.toLowerCase().includes(search.toLowerCase());
      });
    }

    return auxTemplates;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, translation ? translation.title : "Best Practices")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    md: 2,
    className: classes.tagList
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, translation ? translation.filter_by_type : "Filter by type"), types && Object.keys(types).map(function (type) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: types[type],
        onChange: handleChange(type, "type"),
        value: type,
        color: "primary"
      }),
      label: translation ? translation.types[type] : selects.bestpractices_types[type]
    });
  }), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.tagList
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, translation ? translation.filter_by_tags : "Filter by tags"), tags && Object.keys(tags).map(function (tag) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: tags[tag],
        onChange: handleChange(tag),
        value: tag,
        color: "primary"
      }),
      label: tag
    });
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 10,
    md: 10
  }, /*#__PURE__*/React.createElement(FormControl, {
    className: classes.margin
  }, /*#__PURE__*/React.createElement(Input, {
    name: "search",
    value: search,
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(SearchIcon, null)),
    fullWidth: true,
    onChange: handleSearchChange
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      "margin-top": "20px"
    }
  }, createFilteredTemplates().map(function (template, i) {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      md: 4,
      lg: 4
    }, /*#__PURE__*/React.createElement(TemplateCard, Object.assign({}, template, {
      baseUrl: "/projects/best-practices/"
    })));
  }))));
};

export { FranchiseProjectsBestPracticesList };